import { FIELDS } from "./action";

export function mandatoryFieldsReducer(state = {}, action) {
  switch (action.type) {
    case FIELDS.getMandatoryFieldsList.start:
      return {
        ...state,
        fetchingComplete: false,
        MandatoryFieldsList: []
      };
    case FIELDS.getMandatoryFieldsList.success:
      return {
        ...state,
        fetchingComplete: true,
        MandatoryFieldsList: action.data
      };
    case FIELDS.update.start:
      return {
        ...state,
        success: false,
        error: {}
      };
    case FIELDS.update.success:
      return {
        ...state,
        fetchingComplete: true,
        success: true,
        error: {}
      };
    case FIELDS.update.error:
      return {
        ...state,
        fetchingComplete: true,
        success: false,
        error: action.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/mandatoryFields/reducer.js